<svelte:options immutable={true} />

<script>import { createDebug } from '../../../utils/debug.js';
import { setContext } from 'svelte';
import { uniqueId } from '../../../utils/uniqueId.js';
import AbsolutePopupEntry from './AbsolutePopupEntry.svelte';
const debug = createDebug('jsoneditor:AbsolutePopup');
let popups = [];
function openAbsolutePopup(component, props, options) {
    debug('open...', props, options);
    const popup = {
        id: uniqueId(),
        component: component,
        props: props || {},
        options: options || {}
    };
    popups = [...popups, popup];
    return popup.id;
}
function closeAbsolutePopup(popupId) {
    const popupIndex = popups.findIndex((popup) => popup.id === popupId);
    if (popupIndex !== -1) {
        const popup = popups[popupIndex];
        if (popup.options.onClose) {
            popup.options.onClose();
        }
        popups = popups.filter((popup) => popup.id !== popupId);
    }
}
$: debug('popups', popups);
setContext('absolute-popup', { openAbsolutePopup, closeAbsolutePopup });
</script>

{#each popups as popup}
  <AbsolutePopupEntry {popup} {closeAbsolutePopup} />
{/each}

<slot />
